import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ChatIconButton from '$app-web/ui-kit/components/chat-icon-button';
import ResizableTextarea from '$app-web/ui-kit/components/resizable-textarea';

import { ROOM_MESSAGE_DRAFT } from '../../constants';
import { useCurrentStudyRooms, useDynamicMethods, useMessagesDraft, useMethods } from '../../state/chat-client.state';
import classes from './styles.module.scss';

const Footer = (props) => {
    const { roomId } = props;

    const { t } = useTranslation();

    const messagesDraft = useMessagesDraft();
    const methods = useMethods();
    const dynamicMethods = useDynamicMethods();
    const currentStudyRooms = useCurrentStudyRooms();

    const messageDraft = messagesDraft.rooms[roomId] || ROOM_MESSAGE_DRAFT;
    const messageDraftNotEmpty = messageDraft.text.length > 0 || messageDraft.files.length > 0;

    const sendMessage = () => {
        if (messageDraftNotEmpty) {
            methods.sendMessageDraftToRoom(roomId, messageDraft);
        }
    };

    return (
        <div className="item">
            {currentStudyRooms[roomId].isArchived && (
                <div className={classes.archivedRoomInfo}>{t('archived_chat_room_messaging_disabled')}</div>
            )}
            {!currentStudyRooms[roomId].isArchived && (
                <div className={clsx('flex items-center content-center', classes.root)}>
                    <div className="item xs-fill">
                        <ResizableTextarea
                            className={clsx('full-width', classes.inputText)}
                            minRows={1}
                            maxRows={3}
                            placeholder={t('write_a_message')}
                            onChange={(event) => dynamicMethods.setRoomMessageDraftAndSendTyping(event.target.value)}
                            onKeyPress={(event) => {
                                if (event.key === 'Enter') {
                                    if (!event.shiftKey) {
                                        event.preventDefault();
                                        sendMessage();
                                    }
                                }
                            }}
                            value={messageDraft.text}
                        />
                    </div>
                    <div className="item xs-auto">
                        <div className="flex justify-center">
                            <div className="item" hidden>
                                <ChatIconButton className={classes.actionButton} icon={['fad', 'paperclip']} color="primary" />
                            </div>
                            <div className="item">
                                <ChatIconButton
                                    className={classes.actionButton}
                                    icon={['fad', 'paper-plane']}
                                    onClick={sendMessage}
                                    disabled={!messageDraftNotEmpty}
                                    fill
                                    color={messageDraftNotEmpty ? 'secondary' : undefined}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

Footer.propTypes = {
    roomId: PropTypes.string.isRequired,
};

export default Footer;
